import { react } from "react";
import HeroSection from "../components/HeroSection";

const Contact = () => {
    return (
        <div className="newspaper-container-wrapper">
            <HeroSection pageType="other" />
            <div className="container py-5">
                <div className="row justify-content-center">
                    <h3>Contact us</h3>
                    <div className="col-md-6">
	                 <p><i className="fas fa-map-marker-alt"></i>237 सिविल लाइन्स, इटावा (उ.प्र.) विशाल प्रिंटर्स, 59 नौरंगाबाद, इटावा (उ.प्र.)</p>
                        <p><i className="fas fa-envelope"></i> info@etawahtimes.com</p>
                        <p><i className="fas fa-phone"></i>+91 9412320994</p>
                    </div>
                    <div className="col-md-6">
                    </div>
                </div>
            </div>
        </div >
    );

};

export default Contact;

